import { Component, Input } from '@angular/core';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { DashboardProgressBarComponent } from '../dashboard-progress-bar/dashboard-progress-bar.component';
import { DashboardTrendListComponent } from '../dashboard-trend-list/dashboard-trend-list.component';
import { ProgressMetric, DashboardMetricCardLayout } from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

@Component({
  selector: 'l-dashboard-progress-metric',
  standalone: true,
  imports: [IconComponent, DashboardProgressBarComponent, DashboardTrendListComponent],
  templateUrl: './dashboard-progress-metric.component.html',
})
export class DashboardProgressMetricComponent {

  @Input({ required: true })
  public metric!: ProgressMetric;

  @Input()
  public layout: DashboardMetricCardLayout = 'default';

}
